module.exports = __webpack_public_path__ + "img/step_7.258c99e6.webp";